import { TenantHeader } from "../../../../../utils/apiHeaders";
import { APIS } from "../api-factory";
import axios from "axios";


export const getALlHubListByData = (page,size,callBack) => {
    axios.get(APIS.GET_ALL_HUB_DETAILS_BYDATA + page + "&noOfEntry=" + size)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const deleteHubByHubId = (id,callBack) => {
    axios.delete(APIS.DELETE_HUB_BY_HUBID + id)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const getcommunityDetailsByTypeById = (type,callBack) => {
    axios.get(APIS.GET_COMMUNITY_DETAILS_BY_TYPE_ID + type)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const SaveUpdateHubByData = (data,callBack) => {
    axios.post(APIS.SAVE_UPDATE_HUB_BY_DATA ,data)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const changeHubStatusbyId = (id,status,callBack) => {
    axios.put(APIS.CHANGE_HUB_STATUS_BY_ID + id + "&status=" + status)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const getHubHeirarchyById = (id,callBack) => {
    axios.get(APIS.GET_HUB_HEIRARCHY_BY_ID + id )
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const getAmuAgentByHubById = (id,callBack) => {
    axios.get(APIS.GET_AMU_AGENTS_BY_HUB_BY_ID + id )
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const getUmappedAmuAgentByHubById = (id,callBack) => {
    axios.get(APIS.GET_UNMAPPED_AMU_AGENTS_BY_HUB_BY_ID + id )
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const DeleteAmuFromHubByIds = (id,commId,callBack) => {
    axios.delete(APIS.DELETE_AMU_FROM_HUB_BYIDS + id + "&amuCommunityId=" +commId)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const AddAmuFromHubByIds = (id,commId,callBack) => {
    axios.post(APIS.ADD_AMU_FROM_HUB_BYIDS + id + "&amuCommunityId=" +commId)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const getDealerInfoForAgentById = (id,callBack) => {
    axios.get(APIS.GET_DEALER_INFO_FOR_AGENT_BY_ID + id )
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const DownloadOverviewHubByData = (id,start,end,state,city,type,callBack) => {
    fetch(APIS.DOWNLOAD_OVERVIEW_HBU_BY_DATA + id + "&startDate=" + start + "&endDate=" + end  + "&state=" + state + "&city=" + city + "&productType=" + type,TenantHeader)
    .then(res => res.blob())
    .then(data => {
      var blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      var excelBlob = new Blob(
        [data],
        { type: 'application/vnd.ms-excel' },
        'excel.xls'
      )
      
      var downloadUrl = URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.href = downloadUrl
      a.download = 'HubReport.xls'
      document.body.appendChild(a)
      a.click()
      callBack(data)
    })
}
export const DownloadAgentDatabyId = (id,start,end,state,city,type,callBack) => {
    fetch(APIS.DOWNLOAD_AGENTS_DATA_BY_ID + id + "&startDate=" + start + "&endDate=" + end  + "&state=" + state + "&city=" + city + "&productType=" + type,TenantHeader)
    .then(res => res.blob())
    .then(data => {
      var blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      var excelBlob = new Blob(
        [data],
        { type: 'application/vnd.ms-excel' },
        'excel.xls'
      )
      
      var downloadUrl = URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.href = downloadUrl
      a.download = 'HubReport.xls'
      document.body.appendChild(a)
      a.click()
      callBack(data)
    })
}

export const SaveHubTargetAssignByData = (data,callBack) => {
    axios.post(APIS.SAVE_HUB_TARGET_ASSIGN_BY_DATA ,data )
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const GetHubTrackingAllByData = (data,callBack) => {
    axios.get(APIS.GET_HUB_TARGET_TRACKING_ALL_BY_DATA + data?.hubId + "&status=" + data?.status + "&page=" + data?.page + "&size=" + data?.size )
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const DownloadHubTargetReportExcelByData = (id,start,end,callBack) => {
    fetch(APIS.DOWNLOAD_HUB_TARGET_REPORT_EXCEL_BY_HUB + id + "&startDate=" + start + "&endDate=" + end )
    .then(res => res.blob())
    .then(data => {
      var blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      var excelBlob = new Blob(
        [data],
        { type: 'application/vnd.ms-excel' },
        'excel.xls'
      )
      
      var downloadUrl = URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.href = downloadUrl
      a.download = 'HubTargetReport.xls'
      document.body.appendChild(a)
      a.click()
      callBack(data)
    })
}